import type { SfccIntegrationConfig } from './sfcc-integration-config.interface';

export const SFCC_CART_PATH_DEFAULTS = {
  cartAddPath: '/Cart-AddProduct',
  cartRemovePath: '/Cart-RemoveProductLineItem',
  cartUpdatePath: '/Cart-UpdateQuantity',
} satisfies Pick<SfccIntegrationConfig, 'cartAddPath' | 'cartRemovePath' | 'cartUpdatePath'>;
